$ ->
  if $('body').is('.information-chat-page')
    # information-chat-dummy subjects switcher
    $('.current-subject').on 'click', (e) ->
      $('#information-chat-dummy-toggle').slideToggle 'fast'
      e.stopPropagation()

    $('#information-chat-dummy-toggle').on 'click', 'li', (e) ->
      subject = $(this).data('subject')
      subject_val = $(this).children('span').text()
      $('.current-subject span').text subject_val
      $('#information-chat-dummy-subjects > span b').text subject_val
      $('.current-subject .sprites-subjects-24').removeClass().addClass 'sprites-subjects-24 ' + 'sprites-subjects-24--' + subject
      $('#information-chat-dummy-toggle li').show()
      $(this).hide()

    $(document).on 'click', (e) ->
      $('#information-chat-dummy-toggle').hide()
